import React from 'react';
import App from './App';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { store, persistor } from './store/store'
import { PersistGate } from 'redux-persist/integration/react'
import './stylesheets/main_style.css'
import {
  BrowserRouter as Router
} from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>    
        <App /> 
      </Router>
    </PersistGate>
  </Provider>
);
